// src/utils/rolesOptions.js
export const ROLE_OPTIONS = [
  { id: 1, label: "Administrateur" },
  { id: 2, label: "Utilisateur" },
  { id: 3, label: "Dirigeant Club" },
  { id: 4, label: "Arbitrage" },
  { id: 5, label: "Responsable Arbitrage" },
  { id: 6, label: "Membre de la Ligue NA" },
  { id: 7, label: "Responsables Comités Départementaux" },
  { id: 8, label: "Enseignant-Coach" },
];
